import React, {Fragment} from 'react'
import {useRouteLoaderData} from '@remix-run/react'
import clsx from 'clsx'
import {getDomainConfig} from '~/domains'
import {getTranslation} from '~/localization/translation'
import type {RootLoaderResponse} from '~/types'

const QuickNavigation = () => {
  const {language, domain, locale} = useRouteLoaderData('root') as RootLoaderResponse
  const translations = getTranslation(language)
  const {styles: stylesBydomain} = getDomainConfig(domain, locale)

  return (
    <ul className="mb-3 flex list-none flex-row tablet:justify-between">
      {translations.Header.quickNavigation.map(({id, value, label}, i) => {
        return (
          <Fragment key={`${id}-${i}`}>
            <li
              className={clsx(
                'px-10 py-2 tablet:flex tablet:w-full tablet:px-0',
                stylesBydomain.LISTPAGE_WIDGETS_QUICK_NAVIGATION_BORDER,
                stylesBydomain.LISTPAGE_WIDGETS_QUICK_NAVIGATION_TEXT,
                i === 0 && 'border-b-2 font-semibold',
                'listpage_widgets_quick_navigation_text listpage_widgets_quick_navigation_border',
              )}
            >
              <a href={`#${value}`} className="cursor-pointer text-[18px] tablet:mx-auto tablet:text-sm">
                {label}
              </a>
            </li>
          </Fragment>
        )
      })}
    </ul>
  )
}

export default QuickNavigation
